import React, { useState } from "react";
import { Modal, Button } from "antd";
import ServiceForm from "../Service/ServiceForm";

const AddServiceModal = ({ onServiceAdded }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleSuccess = (newService) => {
    if (onServiceAdded) onServiceAdded(newService);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        color={"cyan"}
        variant="outlined"
        onClick={showModal}>
        + Ծառայություն
      </Button>
      <Modal
        title="Ավելացնել Ծառայություն"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        destroyOnHidden
      >
        <ServiceForm
          onSuccess={handleSuccess}
          action="Add Service"
        />
      </Modal>
    </>
  );
};

export default AddServiceModal;
